import Event from '../event';

class PlayerEvent {
    constructor(core) {
        this.core = core;
        this.event = new Event();

        for (const key in core) {
            if (!this[key]) {
                this[key] = core[key];
            }
        }
    }

    on(eventName, callback) {
        if (eventName !== 'ended') {
            this.core.on(eventName, callback);
        } else {
            this.event.on(eventName, callback);
        }
    }

    off(eventName, callback) {
        if (eventName !== 'ended') {
            this.core.off(eventName, callback);
        } else {
            this.event.off(eventName, callback);
        }
    }

    trigger(eventName) {
        this.event.trigger(eventName);
    }
}

export default PlayerEvent;
